<div class="row">
  <div class="tab-wrapper planning-module-permissions col-12">
    <div class="d-flex mt-8 mb-32 checkbox-wrapper">
      <app-checkbox
        id="canAccesPlanningModule"
        [isChecked]="hasAccessToModule() || isInPrimaryRole"
        [disabled]="isInPrimaryRole"
        (checked)="selectPlanningUserRole($event)"
      ></app-checkbox>
      <span>{{ T.settings.employees_departments_org.manage_employee.can_access_planning_module | translate }}</span>
    </div>
    <div class="projects-and-tasks" *ngIf="hasAccessToModule() || isInPrimaryRole">
      <div class="sub-section-label d-flex mt-16 mb-16">
        <app-details-icon type="Task_Group" size="24" outlined="true"></app-details-icon>
        <span class="ml-8">{{ localisedProjects }} & {{ localisedTasks }}</span>
      </div>
      <div class="projects-and-tasks__role-permissions">
        <div class="permissions-selection row mb-8">
          <span class="col-4 text-left" style="font-size: 14px">{{
            T.settings.my_preferences.permissions.employee_roles.item_admin | translate: { item: localisedProject }
          }}</span>
          <app-checkbox
            id="isProjectAdmin"
            class="col-3 d-flex"
            [isChecked]="isInRole(employeeRoleTypes.Project_Admin) || isInPrimaryRole"
            [disabled]="isInPrimaryRole"
            (checked)="selectProjectAdmin($event)"
          ></app-checkbox>
          <app-button-transparent
            class="col-5 text-left"
            [app-tooltip]="{
              title:
                T.settings.my_preferences.permissions.employee_roles.item_admin | translate: { item: localisedProject },
              message:
                T.settings.my_preferences.permissions.localisedProject_admin_tooltip
                | translate: { localisedProject: localisedProject }
            }"
            size="small"
            icon="error_outline"
            [text]="T.common.learn_more | translate"
            iconFontSize="16"
          ></app-button-transparent>
        </div>
      </div>
      <div class="d-flex sub-section-sub-label mt-24 mb-8">
        <span>{{
          T.settings.employees_departments_org.manage_employee.localisedEmployee_can_see
            | translate: { localisedEmployee: localisedEmployee }
        }}</span>
      </div>
      <div class="projects-tasks-read-permissions">
        <div class="projects-selection row mb-12">
          <div class="col-12 col-md-4 mb-2 mb-md-0 d-flex align-items-center">
            <app-checkbox
              id="canSeeAllProjects"
              [isChecked]="
                hasReadPermission(moduleTypes.Planning, filterTypes.Project, [0], false) ||
                hasWritePermission(filterTypes.Project, [0], false) ||
                isInPrimaryRole
              "
              [disabled]="
                isInPrimaryRole ||
                hasWritePermission(filterTypes.Project, [0], false) ||
                isInRole(employeeRoleTypes.Project_Admin)
              "
              (checked)="
                changePermission(
                  $event,
                  filterTypes.Project,
                  0,
                  readWriteTypes.read,
                  readProjectsNonConfidentialDepVisibility,
                  false
                )
              "
            >
            </app-checkbox
            ><span class="ml-8"> {{ T.common.all_items | translate: { items: localisedProjects } }}</span>
          </div>
          <app-filter-dropdown-new
            id="seeProjects"
            class="col-12 col-md-8"
            [filterType]="filterTypes.Project"
            [filterByModuleObjectType]="false"
            [appliedFilters]="readProjectsFilters"
            [label]="T.common.select_items | translate: { items: localisedProjects }"
            [excludeFilterValues]="confidentialProjectIDs"
            (onFilterUpdate)="
              onFiltersChange(
                $event,
                moduleTypes.Planning,
                filterTypes.Project,
                readProjectsNonConfidentialDepVisibility,
                readWriteTypes.read,
                false
              )
            "
            [disabled]="
              hasReadPermission(moduleTypes.Planning, filterTypes.Project, [0], false) ||
              isInRole(employeeRoleTypes.Project_Admin) ||
              isDropdownLoading
            "
          ></app-filter-dropdown-new>
        </div>
        <div class="department-radio-buttons row">
          <ng-container *ngIf="hasAnyReadPermission(moduleTypes.Planning, filterTypes.Project)">
            <app-radio-button
              id="canSeeProjectsAllDepartments"
              class="mb-2 mb-md-0 col-12 col-md-4"
              [checked]="
                readProjectsNonConfidentialDepVisibility === departmentVisibilites.All_Departments || isInPrimaryRole
              "
              [disabled]="
                isInPrimaryRole ||
                (hasAnyWritePermission(moduleTypes.Planning, filterTypes.Project) &&
                  writeProjectsNonConfidentialDepVisibility === departmentVisibilites.All_Departments) ||
                isInRole(employeeRoleTypes.Project_Admin)
              "
              [text]="T.common.all_items | translate: { items: localisedDepartments }"
              (checkedChanged)="
                changeDepartmentVisibility(
                  departmentVisibilites.All_Departments,
                  filterTypes.Project,
                  readWriteTypes.read
                )
              "
            >
            </app-radio-button>
            <app-radio-button
              id="canSeeOnlyProjectsTheirDepartments"
              class="mb-2 mb-md-0 col-12 col-md-5"
              *ngIf="isDepartmentSelected"
              [checked]="readProjectsNonConfidentialDepVisibility === departmentVisibilites.Only_User_Department"
              [text]="T.common.only_their_localisedDepartment | translate: { localisedDepartment: localisedDepartment }"
              [disabled]="
                isInPrimaryRole ||
                (hasAnyWritePermission(moduleTypes.Planning, filterTypes.Project) &&
                  writeProjectsNonConfidentialDepVisibility === departmentVisibilites.All_Departments) ||
                isInRole(employeeRoleTypes.Project_Admin)
              "
              (checkedChanged)="
                changeDepartmentVisibility(
                  departmentVisibilites.Only_User_Department,
                  filterTypes.Project,
                  readWriteTypes.read
                )
              "
            >
            </app-radio-button>
            <app-radio-button
              id="readJustOwnedItems"
              class="mb-2 mb-md-0 col-12 col-md-3"
              [checked]="readProjectsNonConfidentialDepVisibility === departmentVisibilites.Nothing"
              [text]="T.settings.employees_departments_org.manage_employee.just_owned_items | translate"
              [disabled]=" isInPrimaryRole || (hasAnyWritePermission(moduleTypes.Planning, filterTypes.Project)
              && writeProjectsNonConfidentialDepVisibility === departmentVisibilites.All_Departments) || isInRole(employeeRoleTypes.Project_Admin)"
              (checkedChanged)="changeDepartmentVisibility(departmentVisibilites.Nothing, filterTypes.Project, readWriteTypes.read)">
            </app-radio-button>
          </ng-container>
        </div>
      </div>
      <div class="d-flex sub-section-sub-label mt-24 mb-8">
        <span>{{
          T.settings.employees_departments_org.manage_employee.localisedEmployee_can_edit
            | translate: { localisedEmployee: localisedEmployee }
        }}</span>
      </div>
      <div class="projects-tasks-read-permissions">
        <div class="projects-selection row mb-12">
          <div class="col-12 col-md-4 mb-2 mb-md-0 d-flex align-items-center">
            <app-checkbox
              id="canEditAllDepartments"
              [isChecked]="
                hasWritePermission(filterTypes.Project, [0], false) ||
                isInPrimaryRole ||
                isInRole(employeeRoleTypes.Project_Admin)
              "
              [disabled]="isInPrimaryRole || isInRole(employeeRoleTypes.Project_Admin)"
              (checked)="changePermission($event, filterTypes.Project, 0, readWriteTypes.write, 0, false)"
            >
            </app-checkbox>
            <span class="ml-8">{{ T.common.all_items | translate: { items: localisedProjects } }}</span>
          </div>
          <app-filter-dropdown-new
            id="editProjects"
            class="col-12 col-md-8"
            [excludeFilterValues]="confidentialProjectIDs"
            [filterType]="filterTypes.Project"
            [filterByModuleObjectType]="false"
            [appliedFilters]="writeProjectsFilters"
            [label]="T.common.select_items | translate: { items: localisedProjects }"
            (onFilterUpdate)="
              onFiltersChange($event, moduleTypes.Planning, filterTypes.Project, 0, readWriteTypes.write, false)
            "
            [disabled]="hasWritePermission(filterTypes.Project, [0], false) || isDropdownLoading"
          ></app-filter-dropdown-new>
        </div>
        <div class="department-radio-buttons row">
          <ng-container *ngIf="hasAnyWritePermission(moduleTypes.Planning, filterTypes.Project)">
            <app-radio-button
              id="canEditProjectsAllDepartments"
              class="mb-2 mb-md-0 col-12 col-md-4"
              [checked]="
                writeProjectsNonConfidentialDepVisibility === departmentVisibilites.All_Departments || isInPrimaryRole
              "
              [disabled]="isInPrimaryRole || isInRole(employeeRoleTypes.Project_Admin)"
              [text]="T.common.all_items | translate: { items: localisedDepartments }"
              (checkedChanged)="
                changeDepartmentVisibility(
                  departmentVisibilites.All_Departments,
                  filterTypes.Project,
                  readWriteTypes.write
                )
              "
            >
            </app-radio-button>
            <app-radio-button
              id="canEditOnlyProjectsTheirDepartments"
              class="mb-2 mb-md-0 col-12 col-md-5"
              *ngIf="isDepartmentSelected"
              [checked]="writeProjectsNonConfidentialDepVisibility === departmentVisibilites.Only_User_Department"
              [text]="T.common.only_their_localisedDepartment | translate: { localisedDepartment: localisedDepartment }"
              [disabled]="isInPrimaryRole || isInRole(employeeRoleTypes.Project_Admin)"
              (checkedChanged)="
                changeDepartmentVisibility(
                  departmentVisibilites.Only_User_Department,
                  filterTypes.Project,
                  readWriteTypes.write
                )
              "
            >
            </app-radio-button>
            <app-radio-button
              id="writeJustOwnedItems"
              class="mb-2 mb-md-0 col-12 col-md-3"
              [checked]="writeProjectsNonConfidentialDepVisibility === departmentVisibilites.Nothing"
              [text]="T.settings.employees_departments_org.manage_employee.just_owned_items | translate"
              [disabled]="isInPrimaryRole || isInRole(employeeRoleTypes.Project_Admin)"
              (checkedChanged)="changeDepartmentVisibility(departmentVisibilites.Nothing, filterTypes.Project, readWriteTypes.write)">
            </app-radio-button>
          </ng-container>
        </div>
      </div>
      <div class="sub-section-label d-flex mt-32 mb-16">
        <app-details-icon type="Task_Group" size="24" outlined="true"></app-details-icon>
        <span class="ml-8">{{
          T.settings.my_preferences.permissions.confidential_projects | translate: { projects: localisedProjects }
        }}</span>
      </div>
      <div class="d-flex sub-section-sub-label mt-24">
        <span>{{
          T.settings.employees_departments_org.manage_employee.localisedEmployee_can_see_and_edit
            | translate: { localisedEmployee: localisedEmployee }
        }}</span>
      </div>
      <div class="projects-tasks-read-permissions">
        <div class="projects-selection row mb-12">
          <div class="col-12 col-md-4 mb-2 mb-md-0 d-flex align-items-center">
            <app-checkbox
              id="canSeeAllConfidentialProjects"
              [isChecked]="hasConfidentialPermission(moduleTypes.Planning, filterTypes.Project, [0])"
              [disabled]="isAccountAdmin"
              (checked)="changePermission($event, filterTypes.Project, 0, readWriteTypes.write, 0, true)"
            >
            </app-checkbox>
            <span class="ml-8"> {{ T.common.all_items | translate: { items: localisedProjects } }}</span>
          </div>
          <app-filter-dropdown-new
            id="confidentialProjects"
            class="col-12 col-md-8"
            [filterType]="filterTypes.Project"
            [filterByModuleObjectType]="false"
            [appliedFilters]="confidentialProjectFilters"
            [usePredefinedFilters]="true"
            [label]="T.common.select_items | translate: { items: localisedProjects }"
            [predefinedFilters]="allowedConfidentialProjectFilters"
            (onFilterUpdate)="
              onFiltersChange($event, moduleTypes.Planning, filterTypes.Project, 0, readWriteTypes.write, true)
            "
            [disabled]="
              hasConfidentialPermission(moduleTypes.Planning, filterTypes.Project, [0]) ||
              isAccountAdmin ||
              isDropdownLoading
            "
          ></app-filter-dropdown-new>
        </div>
      </div>
    </div>
  </div>
</div>
